/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1FeedbackFeedbackidClassStudentsId202,
  DeleteApiV1FeedbackFeedbackidClassStudentsId401,
  DeleteApiV1FeedbackFeedbackidClassStudentsId404,
  DeleteApiV1FeedbackFeedbackidClassStudentsId500,
  DeleteApiV1FeedbackFeedbackidClassStudentsIdMutationResponse,
  DeleteApiV1FeedbackFeedbackidClassStudentsIdPathParams,
} from "../../types/feedbackTurmasController/DeleteApiV1FeedbackFeedbackidClassStudentsId.ts";

export const deleteApiV1FeedbackFeedbackidClassStudentsIdPathParamsSchema =
  z.object({
    feedbackId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1FeedbackFeedbackidClassStudentsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1FeedbackFeedbackidClassStudentsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1FeedbackFeedbackidClassStudentsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1FeedbackFeedbackidClassStudentsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsId500>;

export const deleteApiV1FeedbackFeedbackidClassStudentsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1FeedbackFeedbackidClassStudentsId202Schema,
  ) as unknown as ToZod<DeleteApiV1FeedbackFeedbackidClassStudentsIdMutationResponse>;
